import { defineMessages } from 'react-intl';

export const startTimeoutMessages = defineMessages({
  title: {
    defaultMessage: "Couldn't start transcribing",
    id: 'l39l0uxrz1',
    description:
      'Toast title when starting a desktop session takes too long and is abandoned',
  },
  description: {
    defaultMessage: 'The session took too long to start. Please try again.',
    id: 'AnK7LTWrL2',
    description:
      'Toast description when starting a desktop session takes too long and is abandoned',
  },
});

export const inputFallbackMessages = defineMessages({
  title: {
    defaultMessage: 'Selected microphone unavailable',
    id: 'Xc4wfey6jB',
    description: 'Toast title when the chosen desktop mic is gone and another is used',
  },
  description: {
    defaultMessage: 'Recording with {deviceName} instead.',
    id: '8/5sEsc/2x',
    description: 'Toast body naming the mic a desktop recording uses instead',
  },
  systemDefault: {
    defaultMessage: 'System Default',
    id: 'qdtbLkI42D',
    description: 'Label for the operating system default microphone',
  },
});
